var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row mb-5"},[_c('span',{staticClass:"display-4 col-12"},[_vm._v(" "+_vm._s(`${_vm.serviceCenter.name}`)+" - "+_vm._s(_vm.$t("COMMON.SERVICECENTER"))+" ")])]),_c('establishment-list-table',{attrs:{"filterServiceCenter":_vm.serviceCenter.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }